import React, { useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import FormControl from "react-bootstrap/FormControl";

import "../App.css";

export default function LoginLanding() {
  const [authenticationFailed, setAuthenticationFailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const passwordRef = useRef(null);

  function authenticate(passwordValue) {
    fetch("/authenticate_frontend", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: passwordValue }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.authenticated && data.workshop_type) {
          setAuthenticationFailed(false);

          const workshopType = data.workshop_type;
          const storagePrefix = workshopType === 'mission' ? 'mission' : 'film';
          localStorage.setItem(`${storagePrefix}-frontend-password`, passwordValue);

          const redirectPath = workshopType === 'mission' ? '/ai-mission' : '/ai-film';
          window.location.href = redirectPath;
        } else {
          setAuthenticationFailed(true);
        }
      })
      .catch((error) => {
        console.error("Authentication request error:", error);
        setErrorMessage(error.toString());
      });
  }

  const openManageServers = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
    const manageUrl = isDevelopment
      ? 'http://localhost:5000/manage-servers/'
      : '/manage-servers/';
    window.open(manageUrl, '_blank', 'noopener,noreferrer');
  };

  let errorMessageToast = <></>;
  if (errorMessage) {
    errorMessageToast = (
      <ToastContainer position="bottom-center" containerPosition="fixed" style={{ zIndex: 99999 }}>
        <Toast
          show={errorMessage != null}
          onClose={() => setErrorMessage(null)}
          style={{ marginBottom: "90px", backgroundColor: "#dddddd", zIndex: 99999 }}
        >
          <Toast.Header>
            <strong className="me-auto" style={{ fontSize: 'large' }}>Error</strong>
          </Toast.Header>
          <Toast.Body style={{ textAlign: "center" }}>
            {errorMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  }

  let failedText = <></>;
  if (authenticationFailed) {
    failedText = <><br /><span style={{ color: 'red' }}>Authentication failed</span></>;
  }

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      overflow: 'auto'
    }}>
      <div style={{
        backgroundColor: '#f05f40',
        padding: '5px 0px',
        width: '100%',
        position: 'relative',
        zIndex: 10
      }}>
        <Container fluid>
          <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', paddingLeft: '0px' }}>
            <span style={{ color: 'white', fontSize: '28px', lineHeight: '1.2', fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center' }}>
              <strong>STAGE ONE EDUCATION</strong>
              <span style={{ display: 'inline-block', width: '1px', height: '1.4em', backgroundColor: 'white', opacity: 0.7, margin: '0 12px', flexShrink: 0 }}></span>
              Artificial Intelligence Workshop
            </span>
          </div>
        </Container>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        paddingTop: '50px',
        position: 'relative',
        zIndex: 2
      }}>
        <div style={{
          width: '60%',
          maxWidth: '800px',
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 0 15px rgba(240, 95, 64, 0.5)'
        }}>
          <Container className="mt-4">
            <Row className="mb-4">
              <Col>
                <p style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 'normal', fontSize: '16px', marginBottom: '10px' }}>Password:</p>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    const passwordValue = passwordRef.current.value;
                    authenticate(passwordValue);
                  }}
                >
                  <InputGroup>
                    <FormControl
                      type="text"
                      placeholder=""
                      aria-label="Password"
                      aria-describedby="password-addon"
                      ref={passwordRef}
                      autoFocus
                      key="passbox"
                      style={{ fontSize: '150%' }}
                    />
                    <Button type="submit">Submit</Button>
                  </InputGroup>
                </Form>
                {failedText}
              </Col>
            </Row>
            {errorMessageToast}
          </Container>
        </div>
      </div>

      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#999999',
        fontSize: '12px',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 'normal',
        zIndex: 9999
      }}>
        &copy; 2026 Stage One Education, LLC
      </div>

      <div
        className="gear-icon"
        onClick={openManageServers}
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          fontSize: '20px',
          color: 'white',
          cursor: 'pointer',
          zIndex: 1000,
          opacity: 0.1
        }}
      >
        <FontAwesomeIcon icon={faCog} />
      </div>
    </div>
  );
}
